module.exports = __webpack_public_path__ + "img/logo.297f6ec3.png";